"use client";

import { useEffect } from 'react';
import { cleanupExpiredSessions } from '@/src/shared/utils/encryption';

interface SessionCleanupServiceProps {
  cleanupInterval?: number;
  runOnMount?: boolean;
}

export default function SessionCleanupService({
  cleanupInterval = 60 * 60 * 1000,
  runOnMount = true
}: SessionCleanupServiceProps) {

  useEffect(() => {
    if (runOnMount) {
      cleanupExpiredSessions();
    }

    const cleanupTimer = setInterval(() => {
      cleanupExpiredSessions();
    }, cleanupInterval);

    const handleBeforeUnload = () => {
      cleanupExpiredSessions();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      clearInterval(cleanupTimer);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [cleanupInterval, runOnMount]);

  return null;
}